import { Fragment } from 'react';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type DocumentProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
}>;

export function Document({ props }: DocumentProps) {
  return (
    <>
      {[props.children].flat().map((child, index) => {
        if (typeof child === 'string') return <Fragment key={index}>{child}</Fragment>;
        if (child) return <StructuredContentRenderer doc={child} key={index} />;
        return null;
      })}
    </>
  );
}
